import { render, staticRenderFns } from "./formFilesUpload.vue?vue&type=template&id=2e345960"
import script from "./formFilesUpload.vue?vue&type=script&lang=js"
export * from "./formFilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports